import numeral from 'numeral'

export default {
  data: () => ({
    priceBracket: {
      1: {
        bracket: [
          { min: 1000, max: 2000, active: [[38, 35], [78, 75]], discount: 30, base_price: 1.53 },
          { min: 2000, max: 4000, active: [[35, 32], [75, 72]], discount: 30, base_price: 1.07 },
          { min: 4000, max: 8000, active: [[32, 30], [72, 70]], discount: 30, base_price: 0.75 },
          { min: 8000, max: 16000, active: [[30, 28], [70, 68]], discount: 30, base_price: 0.53 },
          { min: 16000, max: 32000, active: [[28, 26], [68, 66]], discount: 30, base_price: 0.37 },
          { min: 32000, max: 64000, active: [[26, 24], [66, 64]], discount: 30, base_price: 0.26 },
          { min: 64000, max: 128000, active: [[24, 22], [64, 62]], discount: 30, base_price: 0.18 },
          { min: 128000, max: 256000, active: [[24, 22], [64, 62]], discount: 30, base_price: 0.13 },
          { min: 256000, max: 512000, active: [[22, 20], [62, 60]], discount: 30, base_price: 0.09 }
        ]
      },
      2: {
        bracket: [
          { min: 10000, max: 16000, active: [[30, 28], [70, 68]], discount: 25, base_price: 0.70 },
          { min: 16000, max: 32000, active: [[28, 26], [68, 66]], discount: 25, base_price: 0.52 },
          { min: 32000, max: 64000, active: [[26, 24], [66, 64]], discount: 25, base_price: 0.39 },
          { min: 64000, max: 128000, active: [[24, 22], [64, 62]], discount: 25, base_price: 0.29 },
          { min: 128000, max: 192000, active: [[24, 22], [64, 62]], discount: 25, base_price: 0.21 },
          { min: 192000, max: 220000, active: [[24, 22], [64, 62]], discount: 25, base_price: 0.15 },
          { min: 192000, max: 250000, active: [[24, 22], [64, 62]], discount: 1, base_price: 0.12 }
        ]
      },
      3: {
        bracket: [
          { min: 10000, max: 16000, active: [[30, 28], [70, 68]], discount: 25, base_price: 1.25 },
          { min: 16000, max: 32000, active: [[28, 26], [68, 66]], discount: 25, base_price: 0.93 },
          { min: 32000, max: 64000, active: [[26, 24], [66, 64]], discount: 25, base_price: 0.70 },
          { min: 64000, max: 128000, active: [[24, 22], [64, 62]], discount: 25, base_price: 0.52 },
          { min: 128000, max: 192000, active: [[24, 22], [64, 62]], discount: 25, base_price: 0.39 },
          { min: 192000, max: 220000, active: [[24, 22], [64, 62]], discount: 25, base_price: 0.30 },
          { min: 220000, max: 250000, active: [[24, 22], [64, 62]], discount: 1, base_price: 0.25 }
        ]
      },
      vbc: {
        bracket: [
          { min: 250, max: 500, active: [[32, 30], [72, 70]], discount: 30, base_price: 2.5 },
          { min: 500, max: 1000, active: [[32, 30], [72, 70]], discount: 30, base_price: 1.75 },
          { min: 1000, max: 2000, active: [[32, 30], [72, 70]], discount: 30, base_price: 1.23 },
          { min: 2000, max: 4000, active: [[32, 30], [72, 70]], discount: 30, base_price: 0.86 },
          { min: 4000, max: 8000, active: [[32, 30], [72, 70]], discount: 30, base_price: 0.60 },
          { min: 8000, max: 16000, active: [[30, 28], [70, 68]], discount: 30, base_price: 0.42 },
          { min: 16000, max: 32000, active: [[28, 26], [68, 66]], discount: 30, base_price: 0.29 },
          { min: 32000, max: 64000, active: [[26, 24], [66, 64]], discount: 30, base_price: 0.21 },
          { min: 64000, max: 128000, active: [[24, 22], [64, 62]], discount: 30, base_price: 0.14 },
          { min: 128000, max: 256000, active: [[24, 22], [64, 62]], discount: 30, base_price: 0.10 },
          { min: 256000, max: 512000, active: [[22, 20], [62, 60]], discount: 30, base_price: 0.07 }
        ]
      }
    },
    addOns: [{
      id: 1,
      label: 'Full Community Management',
      description: 'Are you and your team too busy to manage your organization’s networking community? Zenvoy can do it for you.'
    }, {
      id: 2,
      label: 'Single Sign-On Support (SSO)',
      price: 5000,
      enterprise: true,
      monthly: 250,
      description: 'Will your organization need users to sign-in with a preexisting set of credentials?'
    }, {
      id: 3,
      label: 'Dedicated Server',
      price: 5000,
      monthly: 5000,
      description: 'Does your organization require extensive levels of additional data security, HIPAA, Data Loss Prevention (DLP), e-Discovery & offline backup providers?'
    }, {
      id: 4,
      label: 'Bespoke User Interface (UI)',
      price: 5000,
      monthly: 500,
      enterprise: true,
      description: 'Will your organization need Zenvoy to imitate the look and feel of your preexisting website, intranet or third-party community platform?'
    }, {
      id: 5,
      label: 'Payment Processing',
      price: 1500,
      monthly: 0,
      enterprise: true,
      description: 'Are you planning to charge users to access your networking community features?'
    }]
  }),
  computed: {
    getPerCardCost () {
      var bracket = this.priceBracket.vbc.bracket.filter(bracket => {
        return this.model.size >= bracket.min && this.model.size <= bracket.max
      })[0]

      if (bracket) {
        const ceilPrice = bracket.base_price - (bracket.base_price * bracket.discount / 100)

        const priceDecayRate = Math.log(ceilPrice / bracket.base_price) / bracket.min
        let pricePerMember = bracket.base_price * Math.exp(priceDecayRate * (this.model.size - bracket.min))

        if (this.model.organization_type === 1) {
          pricePerMember = numeral(pricePerMember)
            .multiply(55)
            .divide(100)
            .value()
        }

        return numeral(pricePerMember).value()
      }

      return numeral(this.model.size).multiply(2).value()
    },
    vbcTotal () {
      const total = numeral(this.model.size).multiply(this.getPerCardCost).value()

      return numeral(total).value()
    },
    getTotalAddOns () {
      return this.model.add_ons
        .reduce((carry, item) => {
          return numeral(carry).add(item.price || 0).value()
        }, 0)
    },
    getManagementPrice () {
      return numeral(this.model.size)
          .divide(1000)
          .multiply(25)
          .value()
    },
    getSetupFee () {
      const setupFee = numeral(this.getMonthlyCost)
        .add(this.getTotalAddOns)
        .add(this.getMonthlyCost * 0.25)
        .value()

      if (this.isEnterprise) {
        return [
          this.roundByWholeNumber(numeral(setupFee).subtract(2000).value(), 500),
          this.roundByWholeNumber(numeral(setupFee).add(2000).value(), 500)
        ]
      }

      return setupFee
    },
    aiNetworkingCost () {
      return this.roundByWholeNumber(this.getMembershipFee, 100)
    }
  },
  methods: {
    getMonthlyAddOns (planType = 1) {
      const currentAddOns = this.defaultAddOns[planType]

      const hasCommunityManagement = currentAddOns.filter(item => item.id === 1).length

      let total = currentAddOns
        .filter(item => item.monthly > 0)
        .reduce((carry, item) => {
          return numeral(carry).add(item.monthly || 0).value()
        }, 0)

      if (hasCommunityManagement > 0) {
        total = numeral(this.model.size)
          .divide(1000)
          .multiply(25)
          .add(total)
          .value()
      }

      return total
    },
    getMonthlyCostWithAddOns (planType = 1) {
      let total = this
        .roundByWholeNumber(
          numeral(this.getMonthlyCost(planType)).value()
        , 50)

      if (!this.model.yearly) {
        total += total * 0.10
      }

      return total
    },
    getMonthlyCost (planType = 1) {
      if (this.isEnterprise) {
        return numeral(this.getMembershipFee(planType))
          // .multiply(0.10)
          // .add(this.getMembershipFee(planType))
          .value()
      }

      return this.getMembershipFee(planType)
    },
    getMembershipFee (planType = 1) {
      var bracket = this.getCurrentPriceBracket(planType).filter(bracket => {
        return this.model.size >= bracket.min && this.model.size <= bracket.max
      })[0]

      if (bracket) {
        const ceilPrice = bracket.base_price - (bracket.base_price * bracket.discount / 100)

        const priceDecayRate = Math.log(ceilPrice / bracket.base_price) / bracket.min
        let pricePerMember = bracket.base_price * Math.exp(priceDecayRate * (this.model.size - bracket.min))

        if (this.model.organization_type === 1) {
          pricePerMember = numeral(pricePerMember)
            .multiply(55)
            .divide(100)
            .value()
        }

        return numeral(this.model.size)
          .multiply(pricePerMember)
          .value()
      }

      return numeral(this.model.size).multiply(2).value()
    },
    getCurrentPriceBracket (planType = 1) {
      return this.priceBracket[planType].bracket
    },
    getPerMemberCost (planType = 1) {
      var bracket = this.getCurrentPriceBracket(planType).filter(bracket => {
        return this.model.size >= bracket.min && this.model.size <= bracket.max
      })[0]

      if (bracket) {
        const ceilPrice = bracket.base_price - (bracket.base_price * bracket.discount / 100)

        const priceDecayRate = Math.log(ceilPrice / bracket.base_price) / bracket.min
        let pricePerMember = bracket.base_price * Math.exp(priceDecayRate * (this.model.size - bracket.min))

        if (this.model.organization_type === 1) {
          pricePerMember = numeral(pricePerMember)
            .multiply(55)
            .divide(100)
            .value()
        }

        if (!this.model.yearly) {
          pricePerMember += pricePerMember * 0.10
        }

        return numeral(pricePerMember).value()
      }

      return numeral(this.model.size).multiply(2).value()
    },
    roundByWholeNumber (value, precision) {
      const baseValue = value % precision
      const roundedValue = Math.floor(value / precision) * precision
      const remainder = baseValue < precision ? 0 : precision

      return numeral(roundedValue).add(remainder).value()
    }
  }
}
